import { usePlatform } from '../store';
import { HomeGameShelf } from './HomeGameShelf';

export function AllGames() {
  const {data}=usePlatform();
  const games=(data?.games||[]).filter(game=>game.published);
  return <HomeGameShelf id="island-all-games" title="现在开玩" games={games} href="/library" linkLabel="游戏库" expanded/>;
}
